module.exports = __webpack_public_path__ + "static/media/cancel_filled.9001e9c4.svg";